'use client'

import { useRouter } from 'next/navigation'
import { Divider, Menu, theme } from 'antd'
import { navbarMenuItems } from '@/src/data'
import Image from 'next/image'

export const Sidebar = ({ onClose }: { onClose: () => void }) => {
  const router = useRouter()
  const {
    token: { colorBgContainer },
  } = theme.useToken()

  return (
    <>
      <div
        onClick={() => {
          router.push('/home')
          onClose()
        }}
        className='cursor-pointer'
      >
        <Image
          src='/assets/logo/PhysicianGPSLogo.png'
          alt='PhysicianGPS Logo'
          width={120}
          height={120}
          className='min-w-[120px] my-8 w-auto h-auto max-w-full max-h-[80px] mx-auto'
          priority
        />
      </div>
      <Divider
        type='horizontal'
        style={{ marginTop: '0px', marginBottom: '10px' }}
      />
      <Menu
        mode='inline'
        style={{
          height: '100%',
          background: colorBgContainer,
          borderRight: 'none',
          border: 'none',
        }}
        items={navbarMenuItems?.map((item) => {
          if (item && 'label' in item) {
            return {
              ...item,
              label: <span style={{ color: '#06686B' }}>{item.label}</span>,
            }
          }
          return item
        })}
        className='pt-10'
        onClick={onClose}
      />
    </>
  )
}
